<template>
    <section id="default-page">
        <div :class="selected_search ? 'container' : 'container full-width'">
            <div class="row">
                <div class="search-result-top" v-if="selected_search_data">
                    <h2>
                        Recently Searched
                    </h2>
                    <div class="search">
                        <div class="container-search edit-search">
                            <table class="search top-table">
                                <tr>
                                    <td>
                                        <label for="saveSearch">Search Name</label>
                                    </td>
                                    <td colspan="3">
                                        <input type="text" id="saveSearch" class="form-control" placeholder="Search Name" v-model="selected_search_data.name" @change="onChangeName">
                                    </td>
                                </tr>
                            </table>
                            <vehicle-search-form :hide_search_fields="true"></vehicle-search-form>
                        </div>
                    </div>
                    <div class="buttons">
                        <div class="container-buttons">
                            <a href="#" class="btn btn-primary" @click="onSaveSearch">Save</a>
                            <button type="submit" class="btn btn-primary" @click="clearSelected">Cancel</button>
                        </div>
                    </div>
                </div>
                <template v-else>
                    <div class="search-result-top">
                        <div class="top">
                            <div class="left">
                                <h2>
                                    Recently Searched
                                </h2>
                            </div>
                        </div>
                        <div class="bottom">
                        <span v-if="total > 0">
                            <strong>Showing</strong>
                            <span>{{ from }}</span>-<span>{{ to }}</span> of <span>{{ total }}</span>
                            results
                        </span>
                        </div>
                    </div>
                    <div class="container-table">
                        <div class="table-responsive">
                            <b-table
                                    id="saved-search"
                                    class="list-table two-colour"
                                    :fields="fields"
                                    :items="recent_searches"
                                    no-local-sorting
                                    show-empty
                            >
                                <template v-slot:empty="scope">
                                    You have no saved searches...
                                </template>
                                <template v-slot:cell(created_at)="data">
                                    {{dateFormat(data.item.created_at)}}
                                </template>
                                <template v-slot:cell(data)="data">
                                    <span class="year spacing" v-if="data.item.search && (data.item.search.year_min || data.item.search.year_max) ">
                                        <span class="year-min" v-if="data.item.search && data.item.search.year_min">{{data.item.search.year_min}}</span>
                                        <span class="year-min" v-else>min</span>
                                        -
                                        <span class="year-min" v-if="data.item.search && data.item.search.year_max">{{data.item.search.year_max}}</span>
                                        <span class="year-min" v-else>max</span>
                                    </span>
                                    <span class="make spacing" v-if="data.item.search && data.item.search.makes">
                                        <template v-for="make in data.item.search.makes">{{make.name}} </template>
                                    </span>
                                    <span class="model spacing" v-if="data.item.search && data.item.search.model">
                                        {{data.item.search.model}}
                                    </span>
                                    <span class="condition spacing" v-if="data.item.search && (data.item.search.condition_min || data.item.search.condition_max)">
                                        <span class="label">Condition : </span>
                                        <span class="year-min" v-if="data.item.search && data.item.search.condition_min">{{data.item.search.condition_min}}</span>
                                        <span class="year-min" v-else>min</span>
                                        -
                                        <span class="year-min" v-if="data.item.search && data.item.search.condition_max">{{data.item.search.condition_max}}</span>
                                        <span class="year-min" v-else>max</span>
                                    </span>
                                    <span class="condition spacing" v-if="data.item.search && (data.item.search.mileage_min || data.item.search.mileage_max)">
                                        <span class="label">Mileage : </span>
                                        <template v-if="!data.item.search.mileage_min && !data.item.search.mileage_max">
                                            -
                                        </template>
                                        <template v-else>
                                            <span v-if="data.item.search.mileage_min">{{numberWithCommas(data.item.search.mileage_min)}}</span>
                                            <span v-else>min</span>
                                             -
                                            <span v-if="data.item.search.mileage_max">{{numberWithCommas(data.item.search.mileage_max)}}</span>
                                            <span v-else>max</span>
                                        </template>
                                    </span>
                                    <span class="transmission spacing">
                                        <span class="label">Transmission : </span>
                                        <template v-if="data.item.search.transmission === 1">Manual</template>
                                        <template v-else-if="data.item.search.transmission === 2">Automatic</template>
                                        <template v-else-if="data.item.search.transmission === 0">Unknown</template>
                                        <template v-else>All</template>
                                    </span>
                                    <span class="chassis spacing" v-if="data.item.search && data.item.search.chassis">
                                        <span class="label">Chassis : </span>
                                        <span>{{data.item.search.chassis}}</span>
                                    </span>
                                    <span class="exclude_make spacing" v-if="data.item.search && data.item.search.exclude_make">
                                        <span class="label">Exclude : </span>
                                        <template v-if="data.item.search && data.item.search.exclude_make && data.item.search.exclude_make.length">
                                            <span v-for="(make, index) in data.item.search.exclude_make">
                                                {{make.label}}<template v-if="(index+1) < data.item.search.exclude_make.length">, </template>
                                            </span>
                                            <br />
                                        </template>
                                        <template v-if="data.item.search && (data.item.search.exclude_year_min || data.item.search.exclude_year_max)">
                                            {{minMax(null, 'exclude_year', data.item)}}
                                        </template>
                                    </span>
                                    <span class="engine_cc spacing" v-if="data.item.search && (data.item.search.engine_cc_min || data.item.search.engine_cc_max)">
                                        <span class="label">CC : </span>
                                        <span class="year-min" v-if="data.item.search && data.item.search.engine_cc_min">{{data.item.search.engine_cc_min}}</span>
                                        <span class="year-min" v-else>min</span>
                                        -
                                        <span class="year-min" v-if="data.item.search && data.item.search.engine_cc_max">{{data.item.search.engine_cc_max}}</span>
                                        <span class="year-min" v-else>max</span>
                                    </span>
                                    <span class="fuel spacing" v-if="data.item.search && data.item.search.fuel_type">
                                        <span class="label">Fuel : </span>
                                        <span>{{data.item.search.fuel_type}}</span>
                                    </span>
                                    <span class="engine_cc spacing" v-if="data.item.search && (data.item.search.start_bid_min || data.item.search.start_bid_max)">
                                        <span class="label">Bid : </span>
                                        <span class="year-min" v-if="data.item.search && data.item.search.start_bid_min">{{data.item.search.start_bid_min}}</span>
                                        <span class="year-min" v-else>min</span>
                                        -
                                        <span class="year-min" v-if="data.item.search && data.item.search.start_bid_max">{{data.item.search.start_bid_max}}</span>
                                        <span class="year-min" v-else>max</span>
                                    </span>
                                    <span class="lot spacing" v-if="data.item.search && data.item.search.lot">
                                        <span class="label">Lot : </span>
                                        <span>{{data.item.search.lot}}</span>
                                    </span>
                                </template>
                                <template v-slot:cell(actions)="data">
                                    <a v-bind:href="$laravelRouter('search.redirect', data.item.search.id) + '?savedsearch=1&to_form=1'" class="link">Load</a>
                                    <a v-bind:href="$laravelRouter('search.redirect', data.item.search.id) + '?savedsearch=1&exclude_seen=1'" class="link">New</a>
                                    <a v-bind:href="$laravelRouter('search.redirect', data.item.search.id) + '?savedsearch=1'" class="link">Search</a>
                                    <a v-bind:href="$laravelRouter('search.redirect', data.item.search.id) + '?savedsearch=1&next_day=1'" class="link">+1</a>
                                </template>
                            </b-table>
                        </div>
                    </div>
                    <div class="bottom-table">
                        <b-pagination
                                v-if="total > 0"
                                :total-rows="total"
                                v-model="current_page"
                                :per-page="per_page"
                        ></b-pagination>
                        <a href="/auctions" class="btn">Create Search</a>
                        <div class="informations">
                            <strong>To create a Saved Search:</strong>
                            <ol>
                                <li>Perform a search.</li>
                                <li>Use the Save Search button at the bottom of the search results, right side.</li>
                                <li>Visit this page to reuse the search again in the future.</li>
                            </ol>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </section>
</template>
<script>
    import { mapState, mapActions, mapMutations } from 'vuex'
    import {numberWithCommas, searchDataFromModel} from "../../util/common";
    import moment from 'moment'
    export default {
        created(){
            this.getData();
        },
        data() {
            return {
                sort_by: 'created_at',
                sort_desc: false,
                page: 1,
                selected_search: null,
                selected_search_data: null,
                fields: [
                    {label: 'Recent search',    key: 'created_at', sortable: false},
                    {label: '',     key: 'data', sortable: false},
                    // {label: 'Model',    key: 'model', sortable: false},
                    // {label: 'Year',     key: 'year',        formatter: 'minMax'},
                    // {label: 'Cond',     key: 'condition',   formatter: 'minMax'},
                    // {label: 'Mileage',  key: 'mileage',     formatter: 'minMax'},
                    // {label: 'Trans',    key: 'transmission'},
                    // {label: 'Chassis',  key: 'search.chassis'},
                    // {label: 'Exclude',  key: 'exclude_make',},
                    // {label: 'CC',       key: 'engine_cc',   formatter: 'minMax'},
                    // {label: 'Fuel',     key: 'search.fuel_type'},
                    // {label: 'Bid',      key: 'start_bid',   formatter: 'minMax'},
                    // {label: 'Lot',      key: 'search.lot'},
                    {label: '', key: 'actions', class: 'action-buttons', tdClass(value, key, item){
                        let classes = ''
                        if (item.last_searched) {
                            let now = moment()
                            let last = moment(item.last_searched)
                            if (now.isSame(last, 'day')) {
                                classes = 'searched'
                            }

                        }
                        return classes
                    }}
                ]
            }
        },
        computed: {
            ...mapState({
                data: state => state.auction_search.search_data,
                recent_searches: state => state.recent_searches.all,
                per_page: state => state.recent_searches.per_page,
                from: state => state.recent_searches.from,
                to: state => state.recent_searches.to,
                last_page: state => state.recent_searches.last_page,
                total: state => state.recent_searches.total,
            }),
            current_page: {
                get(){
                    return this.$store.getters['recent_searches/current_page'];
                },
                set(value){
                    this.page = value;
                    this.getData();
                }
            }
        },
        methods: {
            dateFormat(value, key, row){
                return window.moment(value).format(this.defaultMomentDateFormat() + ' HH:mm:ss')
            },
            ...mapMutations({
                setSearch: 'auction_search/setSearch',
                setSearchProperty: 'auction_search/setSearchProperty',
            }),
            ...mapActions({
                saveSearch: 'recent_searches/saveSearch',
            }),
            onChangeName(){
                this.setSearchProperty({
                    prop: 'name',
                    value: this.selected_search_data.name
                })
            },
            getData(){
                let data = {
                    page: this.page,
                    per_page: 250,
                    sort_by: this.sort_by,
                    sort_desc: this.sort_desc ? 1 : 0,
                }
                if (this.$route.query.user_id) {
                    data.user_id = this.$route.query.user_id
                }
                return this.$store.dispatch('recent_searches/getAll', data);
            },
            minMax(value, key, row){
                let min = row.search[key+'_min'] || null;
                let max = row.search[key+'_max'] || null;
                if (!min && !max) {
                    return '-'
                }
                return (min ? min : 'min') + ' - ' + (max ? max : 'max')
            },
            clearSelected(){
                this.selected_search_data = null;
                this.selected_search = null;
            },
            onSaveSearch(){
                let args = JSON.parse(JSON.stringify(this.data));
                if (args.make && args.make.name) {
                    args.make = args.make.name;
                }
                if (args.selected_models_proxy) {
                    args.model = Object.keys(args.selected_models_proxy).join(',');
                }
                this.saveSearch(args).then(result => {
                    if (result.message) {
                        this.$message.success(result.message);
                        this.selected_search = null;
                        this.selected_search_data = null;
                        this.getData()
                    } else {
                        this.$message.error('There was a problem saving your search.');
                    }
                }).catch(err => {
                    this.$message.error('There was a problem saving your search.');
                });
            },
            numberWithCommas(val) {
                return numberWithCommas(val);
            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/js/components/RecentSearch/RecentSearch.vue